import { FormItemProps } from "apis";
import { lazy } from "react";

export const PageAdminForm = lazy(() => import("./List"));
export const PageAdminFormCreate = lazy(() => import("./Add"));
export const PageAdminFormUpdate = lazy(() => import("./Edit"));
export const PageAdminFormField = lazy(() => import("./Field"));
export const PageAdminFormBuilder = lazy(() => import("./builder"));
export const PageAdminFormStatus = lazy(() => import("./Status"));
export const PageAdminFormStep = lazy(() => import("./Step"));
export const PageAdminFormStepConfig = lazy(() => import("./StepConfig"));


export interface FormFormValuesProps extends FormItemProps {
    workflowId?: number;
}